export function applyModule ( selector: string, module, ...args ) {
  const el = document.querySelector(selector)
  if(el) { new module(el, ...args) }
}

export function applyModules ( selector: string, module, ...args ) {
  let els = document.querySelectorAll(selector)
  if(els) { 
    els.forEach(el => { new module(el, ...args) })
  }
}